

import underscore from 'underscore';

export default {
  install: function(Vue, options) {
    Vue.prototype.$_ = underscore;
  }
};


export const _= underscore;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-underscore/index.js
// module id = 264
// module chunks = 96